import React from 'react'

const StatusOptions = ({stat ,status ,i}) => {
  
    
  return (
    <option
    value={stat} selected={stat ===status} >{stat}</option>
  )
}

export default StatusOptions